import { z } from 'zod/v4'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v2/pagination'
import { zDayJs } from '@/lib/schema/v2/dayjs'
import { ampApiErrorSchema } from '@/lib/schema/v2/amp-api-response'

export const ticketTypeSchema = z.object({
    created_at: zDayJs.nullish(),
    department_uuid: z.uuid().nullish(),
    name: z.string().nullish(),
    title: z.string().nullish(),
    updated_at: zDayJs.nullish(),
    uuid: z.uuid().nullish(),
})

export const ticketTypesSchema = z.array(ticketTypeSchema)

export const paginatedTicketTypesResponseSchema = z.object({
    data: ticketTypesSchema.nullish(),
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const retrieveTicketTypeResponseSchema = z.object({
    data: ticketTypeSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

const validation_requiredMessage = "You can't leave this empty."

export const ticketTypeFormSchema = z.object({
    title: z
        .string({
            error: validation_requiredMessage,
        })
        .min(1, {
            message: validation_requiredMessage,
        }),
    department_uuid: z.uuid().min(1, {
        message: validation_requiredMessage,
    }),
})

export type PaginatedTicketTypesResponse = z.infer<typeof paginatedTicketTypesResponseSchema>
export type TicketType = z.infer<typeof ticketTypeSchema>
export type TicketTypes = z.infer<typeof ticketTypesSchema>
export type TicketTypeForm = z.infer<typeof ticketTypeFormSchema>
export type RetrieveTicketTypeResponse = z.infer<typeof retrieveTicketTypeResponseSchema>
